import { connect } from "react-redux";
import { Action, Dispatch } from "redux";

import { i18nGetAction } from "../../actions";
import { RootState } from "../../reducers";
import Msg from "../../shared/services/message";
import UserContainer from "./UserContainer";

const mapStateToProps = (state: RootState) => ({
  language: Msg.locale,
  initial: state.applicant.initial,
  initialShared: state.applicant.initialShared,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  changeLanguage: (locale: string) => {
    dispatch(i18nGetAction(locale));
  },
});

/**
 * Wrapped component
 */
const wrappedComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(UserContainer);

export default wrappedComponent;
